import React, { useState, useEffect } from 'react'
import BikePhoto from './BikePhoto'
import './BikeListingGridView.css'
import './BikePhoto.css'
import Skeleton from 'react-loading-skeleton'

const BikeListingGridView = (props) => {
  const [imagesLoading, setImagesLoading] = useState(true)
  const { isMobile, profileImages, bikeData } = props

  const buildImageClassName = (imageIndex, imageLength, isMobile) => {
    if (imageIndex === 0) {
      return 'bike-grid-col-2 bike-grid-row-2'
    } else if (imageLength - 1 === imageIndex) {
      return 'bike-grid-image last-image'
    } else {
      return 'bike-grid-image image-index-' + imageIndex
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setImagesLoading(false)
    }, 1500)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      {imagesLoading && (
        <div
          className={
            'bikephotos-grid-wrapper bike-grid container medium' +
            ' image-length5'
          }
        >
          <div className={buildImageClassName(0, 5)}>
            <Skeleton height="100%" />
          </div>
          <div className={buildImageClassName(1, 5)}>
            <Skeleton height="100%" />
          </div>
          <div className={buildImageClassName(2, 5)}>
            <Skeleton height="100%" />
          </div>
          <div className={buildImageClassName(3, 5)}>
            <Skeleton height="100%" />
          </div>
          <div className={buildImageClassName(4, 5)}>
            <Skeleton height="100%" />
          </div>
        </div>
      )}
      {!imagesLoading && (
        <div
          className={
            'bikephotos-grid-wrapper bike-grid container medium' +
            ' image-length' +
            profileImages.length
          }
        >
          {profileImages.map((image, index) => (
            <BikePhoto
              key={index}
              profileImage={image}
              imageIndex={index}
              isMobile={isMobile}
              imageLength={profileImages.length}
              allImageLength={props.allImages.length}
              bikeData={bikeData}
              profileImages={profileImages}
              isProfileImage={true}
              toggleModal={props.toggleModal}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default BikeListingGridView
